import {
  Container,
  SimpleGrid,
  LinkBox,
  Center,
  LinkOverlay,
  Image,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react'
import { setUpEnvironment } from '../../../utils/environment'

import { skyBoxes } from '../../../../_mocks_/skybox'
import { toggleSkyBox } from '../../../utils/design/customization'

import { Context3D } from '../../../utils/3d-context'
import { IMockSkyBox } from '../../../type/skyboxType'
import { useContext } from 'react'
import { AppContext } from '../../../libs/context'

const SetTheScene = () => {
  const tabSx = {
    flex: 1,
    h: '35px',
    border: '2px solid black',
    borderRadius: '5px',
    bg: 'white',
    color: 'black',
    _selected: {
      color: 'white',
      bg: 'black',
    },
  }

  const { model } = useContext(AppContext)

  return (
    <Container>
      <Tabs variant="unstyled">
        <TabList>
          <Tab sx={tabSx} marginRight="1">
            2D
          </Tab>
          <Tab sx={tabSx} marginLeft="1">
            3D
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <SimpleGrid columns={4} spacing={5}>
              <LinkBox
                as="article"
                cursor="pointer"
                className="material-option-box"
              >
                <Center>
                  <LinkOverlay
                    onClick={() => {
                      toggleSkyBox(Context3D.get(), false)
                      // setUpEnvironment(box.path)
                    }}
                  >
                    <Center
                      w="50px"
                      h="50px"
                      boxShadow="md"
                      borderRadius="50%"
                    ></Center>
                  </LinkOverlay>
                </Center>
                <Text>No Scene</Text>
              </LinkBox>

              {skyBoxes
                .filter(
                  r => r.type === '2d' && r.modelIds?.includes(model.current.id)
                )
                .map((box: IMockSkyBox) => (
                  <LinkBox
                    key={`skybox-2d-thumb-${box.name
                      .toLowerCase()
                      .replaceAll(' ', '-')}`}
                    as="article"
                    cursor="pointer"
                    className="material-option-box"
                  >
                    <Center>
                      <LinkOverlay
                        onClick={() => {
                          toggleSkyBox(Context3D.get(), true)
                          setUpEnvironment(box)
                        }}
                      >
                        <Image
                          src={box.previewUrl}
                          borderRadius="full"
                          boxSize="50px"
                          alt="test"
                          align="center"
                        ></Image>
                      </LinkOverlay>
                    </Center>
                    <Text>{box.name}</Text>
                  </LinkBox>
                ))}
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid columns={4} spacing={5}>
              <LinkBox
                as="article"
                cursor="pointer"
                className="material-option-box"
              >
                <Center>
                  <LinkOverlay
                    onClick={() => {
                      toggleSkyBox(Context3D.get(), false)
                      // setUpEnvironment(box.path)
                    }}
                  >
                    <Center
                      w="50px"
                      h="50px"
                      boxShadow="md"
                      borderRadius="50%"
                    ></Center>
                  </LinkOverlay>
                </Center>
                <Text>No Scene</Text>
              </LinkBox>

              {skyBoxes
                .filter(
                  r => r.type === '3d' && r.modelIds?.includes(model.current.id)
                )
                .map((box: IMockSkyBox) => (
                  <LinkBox
                    key={`skybox-2d-thumb-${box.name
                      .toLowerCase()
                      .replaceAll(' ', '-')}`}
                    as="article"
                    cursor="pointer"
                    className="material-option-box"
                  >
                    <Center>
                      <LinkOverlay
                        onClick={() => {
                          toggleSkyBox(Context3D.get(), true)
                          setUpEnvironment(box)
                        }}
                      >
                        <Image
                          src={box.previewUrl}
                          borderRadius="full"
                          boxSize="50px"
                          alt="test"
                          align="center"
                        ></Image>
                      </LinkOverlay>
                    </Center>
                    <Text>{box.name}</Text>
                  </LinkBox>
                ))}
            </SimpleGrid>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  )
}

export default SetTheScene
